/** @type {Record<string, Record<string, string>>} */
export const onboardingUi = {
  tourButton: {
    en: 'Tour',
    ru: 'Обучение',
    es: 'Tour',
    fr: 'Visite',
    zh: '导览',
    hi: 'टूर',
  },
  tourButtonTitle: {
    en: 'Interactive tour',
    ru: 'Интерактивное обучение',
    es: 'Tour interactivo',
    fr: 'Visite interactive',
    zh: '互动导览',
    hi: 'इंटरैक्टिव टूर',
  },
  offerTitle: {
    en: 'Interactive tour',
    ru: 'Интерактивное обучение',
    es: 'Tour interactivo',
    fr: 'Visite interactive',
    zh: '互动导览',
    hi: 'इंटरैक्टिव टूर',
  },
  offerStart: {
    en: 'Start tour',
    ru: 'Начать обучение',
    es: 'Iniciar tour',
    fr: 'Commencer la visite',
    zh: '开始导览',
    hi: 'टूर शुरू करें',
  },
  offerLater: {
    en: 'Maybe later',
    ru: 'Позже',
    es: 'Más tarde',
    fr: 'Plus tard',
    zh: '以后再说',
    hi: 'बाद में',
  },
  offerDisable: {
    en: "Don't show again",
    ru: 'Отключить обучение',
    es: 'No volver a mostrar',
    fr: 'Ne plus afficher',
    zh: '不再显示',
    hi: 'दोबारा न दिखाएँ',
  },
  offerHint: {
    en: 'Disable auto-prompts anytime in Profile settings, or use “Don’t show again” below.',
    ru: 'Отключить автоподсказки можно в профиле или кнопкой «Не показывать» ниже.',
    es: 'Desactive los avisos automáticos en el perfil o con «No volver a mostrar».',
    fr: 'Désactivez les invitations dans le profil ou avec « Ne plus afficher ».',
    zh: '可在个人资料中关闭自动提示，或点下方「不再显示」。',
    hi: 'प्रोफ़ाइल में या «दोबारा न दिखाएँ» से ऑटो-संकेत बंद करें।',
  },
  next: {
    en: 'Next',
    ru: 'Далее',
    es: 'Siguiente',
    fr: 'Suivant',
    zh: '下一步',
    hi: 'आगे',
  },
  back: {
    en: 'Back',
    ru: 'Назад',
    es: 'Atrás',
    fr: 'Retour',
    zh: '上一步',
    hi: 'पीछे',
  },
  skip: {
    en: 'Skip tour',
    ru: 'Пропустить',
    es: 'Omitir tour',
    fr: 'Ignorer la visite',
    zh: '跳过导览',
    hi: 'टूर छोड़ें',
  },
  finish: {
    en: 'Finish',
    ru: 'Готово',
    es: 'Finalizar',
    fr: 'Terminer',
    zh: '完成',
    hi: 'समाप्त',
  },
  noPageTour: {
    en: 'No guided tour is available for this page yet.',
    ru: 'Для этой страницы пока нет обучения.',
    es: 'Aún no hay tour para esta página.',
    fr: 'Aucune visite guidée pour cette page.',
    zh: '此页面暂无导览。',
    hi: 'इस पेज के लिए अभी कोई टूर नहीं है।',
  },
  toastClose: {
    en: 'OK',
    ru: 'OK',
    es: 'OK',
    fr: 'OK',
    zh: '确定',
    hi: 'ठीक',
  },
};

/**
 * @param {string} roleLabel
 * @param {string} locale
 */
export function offerBody(roleLabel, locale) {
  const bodies = {
    en: `Welcome! We can guide you step by step through the ${roleLabel} interface — highlights, arrows, and tips for what to click and why.`,
    ru: `Добро пожаловать! Проведём вас по интерфейсу (${roleLabel}) — подсветка, стрелки и подсказки: куда нажать и зачем.`,
    es: `¡Bienvenido! Le guiamos paso a paso por la interfaz de ${roleLabel}: resaltados, flechas y consejos sobre qué hacer y por qué.`,
    fr: `Bienvenue ! Nous vous guidons pas à pas dans l’interface ${roleLabel} : surlignage, flèches et conseils.`,
    zh: `欢迎！我们将逐步引导您了解 ${roleLabel} 界面：高亮、箭头和操作说明。`,
    hi: `स्वागत है! हम ${roleLabel} इंटरफ़ेस में कदम दर कदम मार्गदर्शन करेंगे — हाइलाइट, तीर और सुझाव।`,
  };
  return bodies[locale] || bodies.en;
}

/**
 * @param {string} pageLabel
 * @param {string} roleLabel
 * @param {string} locale
 */
export function offerPageBody(pageLabel, roleLabel, locale) {
  const page = pageLabel || 'this page';
  const bodies = {
    en: `Welcome! We can walk you through "${page}" step by step — every section on this screen, tailored to your ${roleLabel} access.`,
    ru: `Добро пожаловать! Пройдём по странице «${page}» — каждый блок на экране с учётом вашей роли (${roleLabel}).`,
    es: `¡Bienvenido! Le guiamos por «${page}»: cada sección de esta pantalla según su acceso de ${roleLabel}.`,
    fr: `Bienvenue ! Visite guidée de « ${page} » — chaque section, adaptée à votre rôle ${roleLabel}.`,
    zh: `欢迎！我们将逐步讲解「${page}」— 根据您的 ${roleLabel} 权限介绍本页每个部分。`,
    hi: `स्वागत है! «${page}» पर चरण दर चरण — आपकी ${roleLabel} भूमिका के अनुसार हर सेक्शन।`,
  };
  return bodies[locale] || bodies.en;
}
